import { useTranslation } from 'i18n';
import { Page, Section } from 'ui';

import { SiteForm } from '../../components/SiteForm/SiteForm';

export const SiteEvidence = () => {
  const { t } = useTranslation('orders');

  return (
    <Page>
      <Page.Title title={t('qualityHomePage.pageTitle')} />
      <Page.Divider />
      <Section>
        <SiteForm />
      </Section>
    </Page>
  );
};
